import React from "react";
import SEO from "@/components/SEO";
import { siteConfig } from "@/config/siteConfig";

const Terms = () => (
  <>
    <SEO
      title="Terms of Use"
      description={`Terms governing the use of ${siteConfig.COMPANY_NAME}'s website, including intellectual property, disclaimers and governing law (Dubai, UAE).`}
      path="/terms"
    />
    <article className="mx-auto max-w-3xl px-6 lg:px-10 py-16 lg:py-24 legal-doc" data-testid="terms-page">
      <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[var(--navy)] tracking-tight">
        Terms of Use
      </h1>
      <p className="mt-3 text-sm text-[var(--slate)]">
        Last updated: {siteConfig.CURRENT_YEAR}
      </p>

      <p className="mt-8">
        These Terms of Use (“Terms”) govern your access to and use of the website of{" "}
        <strong>{siteConfig.COMPANY_NAME}</strong> (“we”, “us”, “our”), based in {siteConfig.ADDRESS_CITY}. By using
        this Site you agree to these Terms. If you do not agree, please do not use the Site.
      </p>

      <h2>1. Purpose of the Site</h2>
      <p>
        The Site provides general information about our range of printing inks, coding consumables and production
        solutions supplied to pharmaceutical manufacturers and distribution partners worldwide. Information on this
        Site is intended for business audiences only and does not constitute an offer, warranty, medical, regulatory
        or professional advice.
      </p>

      <h2>2. Product information and application testing</h2>
      <p>
        All product descriptions, specifications and technical parameters are provided for general reference and are
        <strong> subject to application testing</strong> on your equipment, substrates and production environment.
        Product suitability, compatibility and compliance with any regulatory requirement in your jurisdiction remain
        your responsibility. We make no representation that any product is registered, certified or approved with any
        specific regulatory authority unless expressly stated in writing.
      </p>

      <h2>3. Intellectual property</h2>
      <p>
        All content on the Site, including text, graphics, logos, images, product names and layout, is owned by or
        licensed to {siteConfig.COMPANY_NAME} and is protected by applicable intellectual property laws. You may view
        and print pages for legitimate business enquiry purposes. Any other use, including reproduction, modification,
        distribution, republication or commercial exploitation, requires our prior written consent.
      </p>

      <h2>4. Acceptable use</h2>
      <ul>
        <li>You will not use the Site in a manner that is unlawful, harmful, or infringes any rights of third parties.</li>
        <li>You will not attempt to gain unauthorised access to the Site, its servers or any connected systems.</li>
        <li>You will not upload malicious code or use automated means to scrape or overload the Site.</li>
      </ul>

      <h2>5. Third-party links</h2>
      <p>
        The Site may link to third-party websites. We do not control and are not responsible for the content,
        policies or practices of those websites.
      </p>

      <h2>6. Disclaimers</h2>
      <p>
        The Site and its content are provided on an “as is” and “as available” basis without warranties of any kind,
        express or implied, including implied warranties of merchantability, fitness for a particular purpose and
        non-infringement. We do not warrant that the Site will be uninterrupted, error-free, or free of viruses.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by applicable law, {siteConfig.COMPANY_NAME}, its officers, employees and
        partners will not be liable for any indirect, incidental, special, consequential or punitive damages, or any
        loss of profits, revenues, data or goodwill, arising from your use of, or inability to use, the Site or any
        product information contained on it.
      </p>

      <h2>8. Confidentiality of enquiries</h2>
      <p>
        Information you submit through enquiry, sample request or distributor forms is treated in accordance with our{" "}
        <a href="/privacy-policy">Privacy Policy</a>.
      </p>

      <h2>9. Changes to the Site or Terms</h2>
      <p>
        We may update the Site, its content or these Terms at any time without prior notice. Continued use of the
        Site after changes are posted constitutes acceptance of the revised Terms.
      </p>

      <h2>10. Governing law and jurisdiction</h2>
      <p>
        These Terms are governed by the laws of the Emirate of Dubai and the applicable federal laws of the United
        Arab Emirates. The courts of Dubai shall have exclusive jurisdiction over any dispute arising from or in
        connection with these Terms or your use of the Site.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions about these Terms can be sent to <strong>{siteConfig.EMAIL_SALES}</strong>.
      </p>
    </article>
  </>
);

export default Terms;
